import type { SelectorObject } from '@/types/hubspot';

export const currentStatusItems : Record<string, SelectorObject> = {
  student: {
    value: 'student',
    label: '学生',
    hubspot_name: 'student',
  },
  legal_department_staff: {
    value: 'legal_department_staff',
    label: '法務部員',
    hubspot_name: 'legal_department_staff',
  },
  "non-legal_department_staff": {
    value: 'non-legal_department_staff',
    label: '法務部員以外の社会人',
    hubspot_name: 'non-legal_department_staff',
  },
  others: {
    value: 'others',
    label: 'その他',
    hubspot_name: 'others',
  },
};

export const lastEducationalBackgroundItems : Record<string, SelectorObject> = {
  universities_and_graduate_schools_other_than_law_school: {
    label: '大学・大学院（法学部以外）',
    value: 'universities_and_graduate_schools_other_than_law_school',
    hubspot_name: 'universities_and_graduate_schools_other_than_law_school',
  },
  universities_and_law_school: {
    label: '大学・大学院（法学部）',
    value: 'universities_and_law_school',
    hubspot_name: 'universities_and_law_school',
  },
  others: {
    label: 'その他',
    value: 'others',
    hubspot_name: 'others',
  },
};

export const examHistoryAndQualifications: Record<string, SelectorObject> = {
  "taken_the_bar_exam" : {
    label: '司法試験 受験経験あり',
    value: 'taken_the_bar_exam',
    hubspot_name: 'taken_the_bar_exam',
  },
  "taken_the_preliminary_bar_exam" : {
    label: '司法試験予備試験 受験経験あり',
    value: 'taken_the_preliminary_bar_exam',
    hubspot_name: 'taken_the_preliminary_bar_exam',
  },
  "taken_the_national_civil_service_exam" : {
    label: '国家公務員試験 受験経験あり',
    value: 'taken_the_national_civil_service_exam',
    hubspot_name: 'taken_the_national_civil_service_exam',
  },
  "taken_the_local_civil_service_exam" : {
    label: '地方公務員試験 受験経験あり',
    value: 'taken_the_local_civil_service_exam',
    hubspot_name: 'taken_the_local_civil_service_exam',
  },
  "lawyer_qualification" : {
    label: '弁護士有資格者',
    value: 'lawyer_qualification',
    hubspot_name: 'lawyer_qualification',
  },
  "shiho-shoshi_qualification" : {
    label: '司法書士',
    value: 'shiho-shoshi_qualification',
    hubspot_name: 'shiho-shoshi_qualification',
  },
  "certified_administrative_procedures_legal_specialist_qualification" : {
    label: '行政書士',
    value: 'certified_administrative_procedures_legal_specialist_qualification',
    hubspot_name: 'certified_administrative_procedures_legal_specialist_qualification',
  },
  "patent_attorney_qualification" : {
    label: '弁理士',
    value: 'patent_attorney_qualification',
    hubspot_name: 'patent_attorney_qualification',
  },
};
